<div class="card">
    <h5 class="page-title">Visitor Sessions</h5>

    <div class="filters-panel p-fluid">
        <div class="p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
                <label for="fromDate">From</label>
                <p-calendar
                    inputId="fromDate"
                    [(ngModel)]="draftFilters.from"
                    [showIcon]="true"
                    appendTo="body"
                    dateFormat="yy-mm-dd"
                ></p-calendar>
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label for="toDate">To</label>
                <p-calendar
                    inputId="toDate"
                    [(ngModel)]="draftFilters.to"
                    [showIcon]="true"
                    appendTo="body"
                    dateFormat="yy-mm-dd"
                ></p-calendar>
            </div>
            <div class="p-field p-col-12 p-md-2">
                <label for="landingKey">Landing Key</label>
                <input id="landingKey" type="text" pInputText [(ngModel)]="draftFilters.landingKey" />
            </div>
            <div class="p-field p-col-12 p-md-2">
                <label for="landingPath">Landing Path</label>
                <input id="landingPath" type="text" pInputText [(ngModel)]="draftFilters.landingPath" />
            </div>
            <div class="p-field p-col-12 p-md-2">
                <label for="visitorId">Visitor ID</label>
                <input id="visitorId" type="text" pInputText [(ngModel)]="draftFilters.visitorId" />
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label for="identityFilter">Visitor Type</label>
                <p-dropdown
                    inputId="identityFilter"
                    [options]="identityOptions"
                    [(ngModel)]="draftFilters.identity"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                ></p-dropdown>
            </div>
            <div class="p-field p-col-12 p-md-9 filter-actions">
                <button pButton type="button" label="Apply Filters" icon="pi pi-search" class="button-edit" (click)="applyFilters()"></button>
                <button pButton type="button" label="Clear Filters" icon="pi pi-filter-slash" class="p-button-outlined p-ml-2" (click)="clearFilters()"></button>
            </div>
        </div>
    </div>

    <p-table
        #sessionsTable
        [value]="data"
        [columns]="cols"
        dataKey="sessionId"
        [rows]="pageSize"
        [first]="firstInPage"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[15, 30, 60, 100, totalRecords]"
        [showCurrentPageReport]="true"
        [loading]="isLoading"
        styleClass="p-datatable-customers p-datatable-gridlines"
        [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [lazy]="true"
        (onLazyLoad)="loadData($event)"
        [autoLayout]="true"
    >
        <ng-template pTemplate="caption">
            <div class="p-d-flex">
                <button
                    type="button"
                    pButton
                    pRipple
                    icon="pi pi-file-o"
                    (click)="sessionsTable.exportCSV()"
                    class="p-mr-2 button-edit"
                    label="Export CSV"
                ></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Created</th>
                <th>Last Activity</th>
                <th>Session</th>
                <th>Visitor</th>
                <th>Type</th>
                <th>User</th>
                <th>Landing</th>
                <th>Origin / UTM</th>
                <th>Language</th>
                <th>Device</th>
                <th>Events</th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>
                    <span>{{ item.createdAt ? (item.createdAt | date:'medium') : '-' }}</span>
                </td>
                <td>
                    <span>{{ item.lastActivityAt ? (item.lastActivityAt | date:'medium') : '-' }}</span>
                </td>
                <td>
                    <span [title]="item.sessionId || ''">{{ shortId(item.sessionId) }}</span>
                </td>
                <td>
                    <span [title]="item.visitorId || ''">{{ shortId(item.visitorId) }}</span>
                </td>
                <td>
                    <span [class]="'identity-tag ' + (item.identified ? 'identified' : 'anonymous')">
                        {{ formatIdentity(item.identified) }}
                    </span>
                </td>
                <td>
                    <span [title]="item.userId || ''">{{ item.userId ? shortId(item.userId) : '-' }}</span>
                </td>
                <td>
                    <span>{{ formatLanding(item) }}</span>
                </td>
                <td>
                    <span>{{ formatSourceSummary(item) }}</span>
                </td>
                <td>
                    <span>{{ safeDash(item.language) }}</span>
                </td>
                <td>
                    <span>{{ safeDash(item.deviceType) }}</span>
                </td>
                <td>
                    <span>{{ safeDash(item.eventCount) }}</span>
                </td>
                <td class="actions-col p-text-center">
                    <button pButton icon="pi pi-eye" class="button-view" (click)="viewItem(item)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="12">No visitor sessions found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog
    [(visible)]="isDetailOpen"
    [style]="{ width: '900px', maxWidth: '100%' }"
    header="Visitor Session Details"
    [modal]="true"
    styleClass="p-fluid"
    (onHide)="hideDetailDialog()"
>
    <ng-template pTemplate="content">
        <div *ngIf="isDetailLoading" class="detail-loading">
            <p-progressSpinner></p-progressSpinner>
        </div>

        <div *ngIf="!isDetailLoading && detailSession">
            <h6 class="detail-section-title">Session Summary</h6>
            <div class="p-formgrid p-grid detail-summary">
                <div class="p-field p-col-12 p-md-6">
                    <label>Session ID</label>
                    <div>{{ safeDash(detailSession.sessionId) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Visitor ID</label>
                    <div>{{ safeDash(detailSession.visitorId) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Type</label>
                    <div>{{ formatIdentity(detailSession.identified) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>User ID</label>
                    <div>{{ safeDash(detailSession.userId) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Created</label>
                    <div>{{ detailSession.createdAt ? (detailSession.createdAt | date:'medium') : '-' }}</div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Last Activity</label>
                    <div>{{ detailSession.lastActivityAt ? (detailSession.lastActivityAt | date:'medium') : '-' }}</div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Landing Key</label>
                    <div>{{ safeDash(detailSession.landingKey) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Landing Path</label>
                    <div>{{ safeDash(detailSession.landingPath) }}</div>
                </div>
                <div class="p-field p-col-12">
                    <label>Source / UTM</label>
                    <div>{{ formatSourceSummary(detailSession) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Language</label>
                    <div>{{ safeDash(detailSession.language) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Device</label>
                    <div>{{ safeDash(detailSession.deviceType) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Event Count</label>
                    <div>{{ safeDash(detailSession.eventCount) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Last Event Type</label>
                    <div>{{ safeDash(detailSession.lastEventType) }}</div>
                </div>
            </div>

            <h6 class="detail-section-title">Landing journey</h6>
            <ul class="journey-list">
                <li *ngFor="let line of summarizeLandingJourney(detailEvents)">{{ line }}</li>
            </ul>

            <h6 class="detail-section-title detail-section-title-with-actions">
                <span>Event Timeline</span>
                <span class="detail-export-actions">
                    <button
                        pButton
                        pRipple
                        type="button"
                        label="Copy Session JSON"
                        icon="pi pi-copy"
                        class="p-button-outlined p-button-sm button-edit"
                        [disabled]="isDetailLoading || !detailSession"
                        (click)="copySessionJson()"
                    ></button>
                    <button
                        pButton
                        pRipple
                        type="button"
                        label="Copy AI Prompt"
                        icon="pi pi-comment"
                        class="p-button-outlined p-button-sm p-ml-2"
                        [disabled]="isDetailLoading || !detailSession"
                        (click)="copyAiPrompt()"
                    ></button>
                </span>
            </h6>
            <p-table
                [value]="detailEvents"
                styleClass="p-datatable-gridlines"
                [autoLayout]="true"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>Time</th>
                        <th>Type</th>
                        <th>Summary</th>
                        <th>Route</th>
                        <th>Landing / Page</th>
                        <th>Source / UTM</th>
                        <th>Metadata</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-event>
                    <tr>
                        <td>
                            <span>{{ formatEventTimestamp(event) ? (formatEventTimestamp(event) | date:'medium') : '-' }}</span>
                        </td>
                        <td>{{ safeDash(event.eventType || event.type) }}</td>
                        <td>{{ formatEventSummary(event) }}</td>
                        <td>{{ getEventRoute(event) }}</td>
                        <td>{{ getEventLanding(event) }}</td>
                        <td>{{ getEventSource(event) }}</td>
                        <td class="metadata-cell">{{ getEventMetadata(event) }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">No events recorded for this session.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button
            pButton
            pRipple
            label="Copy Session JSON"
            icon="pi pi-copy"
            class="p-button-outlined button-edit"
            [disabled]="isDetailLoading || !detailSession"
            (click)="copySessionJson()"
        ></button>
        <button
            pButton
            pRipple
            label="Copy AI Prompt"
            icon="pi pi-comment"
            class="p-button-outlined p-ml-2"
            [disabled]="isDetailLoading || !detailSession"
            (click)="copyAiPrompt()"
        ></button>
        <button pButton pRipple label="Close" icon="pi pi-times" class="p-button-text p-ml-2" (click)="hideDetailDialog()"></button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="isManualCopyOpen"
    [header]="manualCopyTitle || 'Copy manually'"
    [style]="{ width: '720px', maxWidth: '100%' }"
    [modal]="true"
    styleClass="p-fluid"
    (onHide)="closeManualCopyDialog()"
>
    <ng-template pTemplate="content">
        <p class="manual-copy-hint">Select the text below and copy it manually.</p>
        <textarea
            pInputTextarea
            class="manual-copy-textarea"
            [rows]="16"
            readonly
            [(ngModel)]="manualCopyText"
            (focus)="$any($event.target).select()"
        ></textarea>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Close" icon="pi pi-times" class="p-button-text" (click)="closeManualCopyDialog()"></button>
    </ng-template>
</p-dialog>
